import React from "react";
import { Theme, useTheme, css } from "@emotion/react";

type Props = {
    children: React.ReactNode,
    contentAlignment?: string,
};

const HeaderAndButtonsContainer: React.FC<Props> = ({ children, contentAlignment = "left" }) => {
    const theme: Theme = useTheme();

    const headerAndButtonsContainer = css`
        display: flex;
        flex-direction: column;
        position: relative;
        height: 100%;
        width: 480px;
        justify-content: center;
        ${contentAlignment === "Right" && "margin-left: auto;"}

        ${theme.breakpoints.down("md")} {
            height: 50%;
            align-self: end;
        }
    `;

    return (
        <div css={headerAndButtonsContainer}>
            {children}
        </div>
    );
}

export default HeaderAndButtonsContainer;
